export default function distinct(value, index, self) {
  return self.indexOf(value) === index;
}
